module.exports = __webpack_public_path__ + "img/Illegal_building-01.a2774b0f.jpg";